import CeText from "@/components/Article/ContentElements/CeText.vue";
import CeTextImage from "@/components/Article/ContentElements/CeTextImage.vue";
import CeImage from "@/components/Article/ContentElements/CeImage.vue";
import CeTextVideo from "@/components/Article/ContentElements/CeTextVideo.vue";
import CeVideo from "@/components/Article/ContentElements/CeVideo.vue";
import CeImageGallery from "@/components/Article/ContentElements/CeImageGallery.vue";
import CeListFiles from "@/components/Article/ContentElements/CeListFiles.vue";
import CeListContacts from "@/components/Article/ContentElements/CeListContacts.vue";
import CeListArticles from "@/components/Article/ContentElements/CeListArticles.vue";
import CeListChecklistArticles from "@/components/Article/ContentElements/CeListChecklistArticles.vue";
import CeListChecklist from "@/components/Article/ContentElements/CeListChecklist.vue";

export const ContentType = {
  Text: "CeText",
  TextImage: "CeTextImage",
  TextVideo: "CeTextVideo",
  Image: "CeImage",
  ImageGallery: "CeImageGallery",
  Video: "CeVideo",
  ArticleList: "CeListArticles",
  Checklist: "CeListChecklist",
  ArticleChecklist: "CeListChecklistArticles",
  ContactList: "CeListContacts",
  FileList: "CeListFiles",
};

export const ContentTypeModal = {
  texts: {
    Text: {
      template: ContentType.Text,
      title: "Text",
      icon: "fas fa-align-left",
    },
    TextImage: {
      template: ContentType.TextImage,
      title: "Text med bild",
      icon: "fas fa-image fa-fw",
    },
    TextVideo: {
      template: ContentType.TextVideo,
      title: "Text med video",
      icon: "fas fa-video fa-fw",
    },
  },
  media: {
    Image: {
      template: ContentType.Image,
      title: "Bild",
      icon: "fas fa-image fa-fw",
    },
    ImageGallery: {
      template: ContentType.ImageGallery,
      title: "Bildgalleri",
      icon: "fas fa-images fa-fw",
    },
    Video: {
      template: ContentType.Video,
      title: "Video",
      icon: "fas fa-video",
    },
  },
  lists: {
    ArticleList: {
      template: ContentType.ArticleList,
      title: "Lista med artiklar",
      icon: "fas fa-list-ul fa-fw",
    },
    ContactList: {
      template: ContentType.ContactList,
      title: "Lista med kontakter",
      icon: "fas fa-user-friends fa-fw",
    },
    FileList: {
      template: ContentType.FileList,
      title: "Lista med filer",
      icon: "fas fa-file-alt fa-fw",
    },
  },
  checkLists: {
    Checklist: {
      template: ContentType.Checklist,
      title: "Checklista",
      icon: "fas fa-tasks fa-fw",
    },
    ArticleChecklist: {
      template: ContentType.ArticleChecklist,
      title: "Checklista med artiklar",
      icon: "fas fa-tasks fa-fw",
    },
  },
};

export const Components = {
  CeText,
  CeTextImage,
  CeTextVideo,
  CeImage,
  CeVideo,
  CeImageGallery,
  CeListFiles,
  CeListContacts,
  CeListArticles,
  CeListChecklistArticles,
  CeListChecklist,
};
